import React, { useState, useEffect } from "react";
import Productgrid from "./Productgrid";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import Slider from "react-slick";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useMemo } from "react";
import { Link } from "react-router-dom";
function BestSelling({ data }) {
  const [activeStick, setActiveStick] = useState(""); // To manage the active stick button
  const [gridactive, setGridactive] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Loader state
  // Set initial grid class and active stick based on screen size
  useEffect(() => {
    const mediaQuery991 = window.matchMedia("(max-width: 991px)");
    const mediaQuery767 = window.matchMedia("(max-width: 767px)");
    const mediaQuery575 = window.matchMedia("(max-width: 575px)");

    // Function to set the appropriate grid layout and stick button
    const handleScreenChange = () => {
      if (mediaQuery575.matches) {
        // Below 575px: Activate single-grid and the corresponding stick button
        setActiveStick("stick_two");
        setGridactive("grid_two");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 2,
        }));
      } else if (mediaQuery767.matches) {
        // Below 767px: Activate two-grid and the corresponding stick button
        setActiveStick("stick_two");
        setGridactive("grid_two");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 2,
        }));
      } else if (mediaQuery991.matches) {
        setActiveStick("stick_three");
        setGridactive("grid_three");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 3,
        }));
      } else {
        // Web: Activate four-grid and the corresponding stick button

        setActiveStick("stick_six");
        setGridactive("grid_six");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 6,
        }));
      }
    };

    // Initial check and setting up event listeners
    handleScreenChange(); // Check initial state
    mediaQuery575.addEventListener("change", handleScreenChange);
    mediaQuery767.addEventListener("change", handleScreenChange);
    mediaQuery991.addEventListener("change", handleScreenChange);

    // Cleanup event listeners on component unmount
    return () => {
      mediaQuery575.removeEventListener("change", handleScreenChange);
      mediaQuery767.removeEventListener("change", handleScreenChange);
      mediaQuery991.removeEventListener("change", handleScreenChange);
    };
  }, []);

  // Stick button handlers
  function stickhandleone() {
    setActiveStick("stick_one");
    setGridactive("grid_one");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 1,
    }));
  }

  function stickhandletwo() {
    setActiveStick("stick_two");
    setGridactive("grid_two");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 2,
    }));
  }

  function stickhandlethree() {
    setActiveStick("stick_three");
    setGridactive("grid_three");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 3,
    }));
  }

  function stickhandlefour() {
    setActiveStick("stick_four");
    setGridactive("grid_four");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 4,
    }));
  }

  function stickhandlesix() {
    setActiveStick("stick_six");
    setGridactive("grid_six");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 6,
    }));
  }

  const CustomPrevArrow = ({ onClick }) => {
    return (
      <button className="custom-prev-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    );
  };

  const CustomNextArrow = ({ onClick }) => {
    return (
      <button className="custom-next-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    );
  };

  const [sliderSettings, setSlidersettings] = useState({
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    margin: 8,
    nav: true,
    draggable: true,
    loop: false,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  });

  useEffect(() => {
    if (data) {
      setIsLoading(false); // Once data is available, stop loading
    }
  }, [data]);

  return (
    <section className="new_products_section related-products-section col_divide_design pt-sm-40 pb-40">
      <div className="container">
        <div className="row first_row">
          <div className="col-xl-3 col-lg-3 col-12 main-stick-inner">
            <div className="main-stick">
              <div
                onClick={stickhandleone}
                className={`${
                  activeStick === "stick_one"
                    ? "active-bg-grid"
                    : "sticks-inner-box"
                } stick_one`}
              >
                <button
                  className={
                    activeStick === "stick_one"
                      ? "stickhandleone-one"
                      : "stick-color"
                  }
                ></button>
              </div>
              <div
                onClick={stickhandletwo}
                className={`${
                  activeStick === "stick_two"
                    ? "active-bg-grid"
                    : "sticks-inner-box"
                } stick_two`}
              >
                <button
                  className={
                    activeStick === "stick_two"
                      ? "stickhandleone-two"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_two"
                      ? "stickhandleone-two"
                      : "stick-color"
                  }
                ></button>
              </div>
              <div
                onClick={stickhandlethree}
                className={`${
                  activeStick === "stick_three"
                    ? "active-bg-grid"
                    : "sticks-inner-box"
                } stick_three`}
              >
                <button
                  className={
                    activeStick === "stick_three"
                      ? "stickhandleone-three"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_three"
                      ? "stickhandleone-three"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_three"
                      ? "stickhandleone-three"
                      : "stick-color"
                  }
                ></button>
              </div>
              <div
                onClick={stickhandlefour}
                className={`${
                  activeStick === "stick_four"
                    ? "active-bg-grid"
                    : "sticks-inner-box"
                } stick_four`}
              >
                <button
                  className={
                    activeStick === "stick_four"
                      ? "stickhandleone-four"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_four"
                      ? "stickhandleone-four"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_four"
                      ? "stickhandleone-four"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_four"
                      ? "stickhandleone-four"
                      : "stick-color"
                  }
                ></button>
              </div>
              <div
                onClick={stickhandlesix}
                className={`${
                  activeStick === "stick_six"
                    ? "active-bg-grid"
                    : "sticks-inner-box"
                } stick_five`}
              >
                <button
                  className={
                    activeStick === "stick_six"
                      ? "stickhandleone-five"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_six"
                      ? "stickhandleone-five"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_six"
                      ? "stickhandleone-five"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_six"
                      ? "stickhandleone-five"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_six"
                      ? "stickhandleone-five"
                      : "stick-color"
                  }
                ></button>
                <button
                  className={
                    activeStick === "stick_six"
                      ? "stickhandleone-five"
                      : "stick-color"
                  }
                ></button>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-8 main-heading-inner-box">
            <div className="inner-box">
              <img src={leftTree} alt="img" className="heading-left-image" />
              <h3 className="main-heading-1">{data && data.title}</h3>
              <img src={righttree} alt="img" className="heading-right-image" />
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-4 best-sellingviewall">
            <Link to={`/classification_list/${data?.classification_slug}`}>
              View All
            </Link>
          </div>
        </div>
        <div className={`row second_row mt-4 ${gridactive}`}>
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {data ? (
                <Slider {...sliderSettings}>
                  {data.products && data.products.length > 0
                    ? data.products.map((item, index) => (
                        <div className="grid_col" key={item.id || index}>
                          <Productgrid
                            productdetailslink={`product-details/${item.slug}`}
                            items={item}
                          />
                        </div>
                      ))
                    : null}
                </Slider>
              ) : (
                <p className="text-center">No Products available</p>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default BestSelling;
